import styled from "styled-components"

import Button from "@irati/ui/src/Button"
import Icon from "@irati/ui/src/Icon"

export const GoToMapButton = styled(Button).attrs({
  icon: "geoPin",
  size: 12,
  color: ({theme}) => theme.colors.utility.white,
  full: true
})`
  margin: 20px 0;

  ${Icon} {
    stroke: ${({theme}) => theme.colors.utility.black};
  }
`

export const LocationsMapWrapper = styled.div`
  height: 300px;
  margin: 20px 0;
`
